import React, { useState } from 'react';
import { Route, Routes } from 'react-router';
import { HashRouter as Router } from 'react-router-dom';
import SpotifyCallback from '../spotify/SpotifyCallback';
import FallbackHandler from '../FallbackHandler';
import Home from './Home';
import Tool from '../Tool/Tool';
import { ReactComponent as SunIcon } from "../media/sun.svg";
import { ReactComponent as MoonIcon } from "../media/moon.svg";
import { AccessTokenDto } from '../spotify/spotify';

export const TokenContext = React.createContext<{token: AccessTokenDto | null, setToken: (token: AccessTokenDto) => void}>({
  token: null,
  setToken: (token) => {}
});

export const ThemeContext = React.createContext({
  theme: "dark",
  setTheme: (theme: string) => {}
});

const App: React.FC = () => {
  const [ themeVal, setTheme ] = useState("dark");
  const [ token, setToken ] = useState<AccessTokenDto | null>(null);
  return (
    <Router>
        <div className={`w-screen min-h-screen relative ${themeVal === 'dark' ? 'bg-gray-700 text-white' : 'bg-gray-200 text-gray-900'}`}>
          <div className='absolute top-3 right-3 cursor-pointer' onClick={() => setTheme(b => b === "dark" ? "light" : "dark")}>{themeVal === "dark" ? <SunIcon /> : <MoonIcon />}</div>
          <TokenContext.Provider value={{ token: token, setToken }}>
            <ThemeContext.Provider value={{ theme: themeVal, setTheme }}>
              <Routes>
                  <Route path='/callback' element={<SpotifyCallback />} />
                  <Route path='/tool' element={<Tool />} />
                  <Route path='/' element={<Home />} />
                  <Route path='*' element={<FallbackHandler />} />
                </Routes>
              </ThemeContext.Provider>
          </TokenContext.Provider>
        </div>
    </Router>
  );
}

export default App;
